var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 1.4375C14.6186 2.02084 14.1102 2.54166 13.4746 3V3.375C13.4746 5.56251 12.6748 7.54687 11.0752 9.32812C9.47563 11.1094 7.35171 12 4.70339 12C3.00847 12 1.44069 11.5417 0 10.625C0.338985 10.6667 0.582626 10.6875 0.730932 10.6875C2.15043 10.6875 3.4216 10.25 4.54449 9.375C3.88771 9.35417 3.29449 9.15104 2.76483 8.76562C2.23517 8.38021 1.875 7.88542 1.68432 7.28125C1.93856 7.32292 2.12924 7.34375 2.25636 7.34375C2.46822 7.34375 2.74364 7.30208 3.08263 7.21875C2.38347 7.07292 1.79555 6.72396 1.31886 6.17188C0.842159 5.61979 0.603814 4.97917 0.603814 4.25V4.21875C1.06992 4.46875 1.53601 4.59375 2.00212 4.59375C1.0911 4.01041 0.635593 3.16667 0.635593 2.0625C0.635593 1.54166 0.773304 1.04167 1.04873 0.5625C2.68009 2.54168 4.78812 3.59375 7.37288 3.71875C7.33051 3.57292 7.30932 3.34375 7.30932 3.03125C7.30932 2.17708 7.60593 1.45834 8.19915 0.875C8.79238 0.291664 9.5233 0 10.3919 0C11.2606 0 12.0021 0.322913 12.6165 0.96875C13.2521 0.864583 13.9089 0.614585 14.5869 0.21875C14.375 0.94792 13.9195 1.51041 13.2203 1.90625C13.8771 1.84375 14.4703 1.6875 15 1.4375Z",
    fill: "#8D8B97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.0a1329fdcd47579f18a14e16226ef1ab.svg";
export { ForwardRef as ReactComponent };